import { Switch as AntSwitch } from 'antd'
import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 2rem;
`

export const ListTitle = styled.div`
  display: flex;
  font-size: larger;
  font-weight: bold;
  justify-content: space-between;
  margin: 0.5rem 2rem;
`

export const ModalDescription = styled.span`
  font-size: small;
`

export const ModalTitle = styled.span`
  font-size: larger;
  font-weight: bold;
`

export const Switch = styled(AntSwitch)`
  margin-right: 1rem;
  width: 4rem;
`
